import {
  AccountHome,
  AccountPayments,
  AccountPassword,
} from '@/components/account';

import AccountCompanies from '@/components/account/companies/AccountCompanies.vue';
import AccountCompany from '@/components/account/companies/AccountCompany.vue';
import AccountHomeCompanies from '@/components/account/companies/AccountHomeCompanies.vue';
import AccoutAddCompany from '@/components/account/companies/AccountAddCompany.vue';
import AccountHomeAddCompany from '@/components/account/companies/AccountHomeAddCompany.vue';

import AccountInformations from '@/components/account/AccountInformations.vue';
import AccountInformationsHome from '@/components/account/informations/AccountInformationsHome.vue';
import AccountContacts from '@/components/account/informations/AccountContacts.vue';
import AccountMembersInformations from '@/components/account/informations/AccountMembersInformations.vue';
import AccountMembers from '@/components/account/informations/AccountMembers.vue';
import AccountAddMember from '@/components/account/informations/AccountAddMember.vue';

import AccountPaymentsHome from '@/components/account/payments/AccountPaymentsHome.vue';
import AccountPaymentSepa from '@/components/account/payments/AccountPaymentSepa.vue';
import AccountPaymentCard from '@/components/account/payments/AccountPaymentCard.vue';

import AccountPaymentAddSepa from '@/components/account/payments/AccountPaymentAddSepa.vue';
import AccountPaymentAddCard from '@/components/account/payments/AccountPaymentAddCard.vue';

import { AccountView } from '@/views/default';
import { DynamicModal } from '@/views/modal';

import DynamicRouterView from '@/components/common/layout/DynamicRouterView.vue';

const account = {
  path: 'account',
  components: {
    default: AccountView,
    modal: DynamicModal,
  },
  children: [
    {
      path: '',
      component: AccountHome,
    },
    {
      path: 'companies',
      component: AccountHomeCompanies,
      children: [
        {
          path: '',
          component: AccountCompanies,
        },
        {
          path: 'add',
          component: AccountHomeAddCompany,
          children: [
            {
              path: '',
              component: AccoutAddCompany,
            },
            {
              path: 'new',
              component: AccountCompany,
            },
          ],
        },
        {
          path: ':id',
          component: AccountCompany,
        },
      ],
    },
    {
      path: 'informations',
      component: AccountInformations,
      children: [
        {
          path: '',
          component: AccountInformationsHome,
        },
        {
          path: 'contact',
          component: AccountContacts,
        },
        {
          path: 'members',
          component: AccountMembersInformations,
          children: [
            {
              path: '',
              component: AccountMembers,
            },
            {
              path: 'add',
              component: AccountAddMember,
            },
          ],
        },
      ],
    },
    {
      path: 'payments',
      component: AccountPayments,
      children: [
        {
          path: '',
          component: AccountPaymentsHome,
        },
        {
          path: 'sepa',
          component: DynamicRouterView,
          children: [
            {
              path: '',
              component: AccountPaymentSepa,
            },
            {
              path: 'add',
              component: AccountPaymentAddSepa,
            },
          ],
        },
        {
          path: 'credit-cards',
          component: DynamicRouterView,
          children: [
            {
              path: '',
              component: AccountPaymentCard,
            },
            {
              path: 'add',
              component: AccountPaymentAddCard,
            },
          ],
        },
      ],
    },
    {
      path: 'password',
      component: AccountPassword,
    },
  ],
};

export default account;
